<div class="bg-white p-4">
  <div class="row mb-2" style="font-size: 16px">
    <div class="col">
      <div class="url-field m-auto d-flex flex-wrap justify-content-center"
        style="background: #ccc; padding: 1rem 4rem; width: auto; border-radius: 10px;">
        <div (click)=copyInputMessage(apiKey) class="d-flex flex-wrap justify-content-center cursor-pointer">
          {{ 'ss.Products.ApiKey' | translate }}
          &nbsp; <span class="text-dark">{{apiKey}}</span>
          <mat-icon class="text-dark ms-2" aria-hidden="false">content_copy</mat-icon>
        </div>
        <button (click)="confirmAction()" type="button"
          class="btn btn-danger btn-sm d-flex justify-content-center m-0 p-0 ms-2">
          <mat-icon class="text-light" aria-hidden="false">autorenew</mat-icon>
        </button>
      </div>
    </div>

    <div class="col-12 mx-2">
      <div class="form-group mb-0">
        <label for="callbackInput">{{ 'Sellers.Products.CallbackURL' | translate }}<span class="text-danger">*</span></label>
        <input [(ngModel)]="callbackUrl" #callbackInput class="form-control" type="text">
        <p *ngIf="showError()" class="form-error">
          {{ 'Sellers.Products.EnterValidURL' | translate }}
        </p>
      </div>
      <div class="form-group my-4">
        <label class="mb-2 fw-bold">{{'Shopify Integration' | translate}}:</label>
        <div class="form-group my-2">
          <label for="shopNameInput">{{ 'Shop name' | translate }}</label>
          <input [(ngModel)]="shopName" #shopNameInput class="form-control" type="text">
        </div>
        <div class="form-group my-2">
          <label for="shopTokenInput">{{ 'Shop access token'  | translate}}</label>
          <input [(ngModel)]="shopifyAccessToken" #shopTokenInput class="form-control" type="text">
        </div>
      </div>
      <div *ngIf="shopifyAccessToken">
        <p>
          <button class="btn btn-primary" (click)="requestScript()" type="button" data-bs-toggle="collapse" data-bs-target="#codeCollapse" aria-expanded="false" aria-controls="codeCollapse">
           {{'Sellers.Dashboard.ShowScript' | translate }}
          </button>
        </p>
        <div class="collapse" id="codeCollapse">
          <div class="card card-body">
            <div  class="d-flex justify-content-end">
              <mat-icon  (click)=copyInputMessage(sc) class="text-dark ms-2 cursor-pointer" >content_copy</mat-icon>
            </div>
            <pre>
              <code>
                {{sc}}
              </code>
             </pre>
          </div>
        </div>
      </div>

      <form [formGroup]="stepForm" *ngIf="stepForm">
        <div class="row align-items-center mx-0 mb-4">
          <div class="col-md-4" id="payment-options-label">
            <label>{{ 'Sellers.Products.PaymentOptions' | translate }}</label>
          </div>
          <div class="col-md-8" id="payment-options-field">
            <app-payment-options [fieldObject]="paymentOptionsField" [fieldErrors]="formValidator.formErrors"
              [formControlRef]="convertControls('Payment options')" [productType]="productTypeId" [isUpdate]="isUpdate"
              [integrationPage]="true"></app-payment-options>
          </div>
        </div>
        <div class="row align-items-center mx-0 mb-4">
          <div class="col-md-7" id="fees-question-label">
            <label>{{ 'Sellers.Products.FeesBuyer' | translate }}</label>
          </div>
          <div class="col-md-5" id="fees-question-field">
            <app-no-label-toggle [fieldObject]="feesOnBuyerField" [fieldErrors]="formValidator.formErrors"
              [formControlRef]="convertControls('Do you want the fees to be on the buyer?')"
              [productType]="productTypeId" [isUpdate]="isUpdate"></app-no-label-toggle>
          </div>
        </div>
        <div class="row align-items-center mx-0 mb-4">
          <div class="col-md-7" id="fees-question-label">
            <label>{{ 'Sellers.Products.SplitFees' | translate }}</label>
          </div>
          <div class="col-md-5" id="fees-question-field">
            <app-no-label-toggle [fieldObject]="splitFeesField" [fieldErrors]="formValidator.formErrors"
              [formControlRef]="convertControls('Do you want the fees to be split between buyer and seller?')" [productType]="productTypeId"
              [isUpdate]="isUpdate"></app-no-label-toggle>
          </div>
        </div>
        <div class="row align-items-center mx-0 mb-4">
          <div class="col-md-7" id="fees-question-label">
            <label>{{ 'Sellers.Products.VATSeller' | translate }}</label>
          </div>
          <div class="col-md-5" id="fees-question-field">
            <app-no-label-toggle [fieldObject]="VATOnSellerField" [fieldErrors]="formValidator.formErrors"
              [formControlRef]="convertControls('Do you want the VAT to be on buyer?')"
              [productType]="productTypeId" [isUpdate]="isUpdate"></app-no-label-toggle>
          </div>
        </div>
      </form>

      <button (click)="submit()" [disabled]="!isValidURL(callbackUrl)" class="btn btn-primary btn-md mt-2 pull-right">
        {{ 'Sellers.Products.Submit' | translate }}
      </button>
    </div>
  </div>
</div>
